import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentAmortizationSchedule from "../document/DocumentAmortizationSchedule";


function AmortizationSchedule() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="amortization-schedule" parent="5" />
            <HeaderMain slug="amortization-schedule" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentAmortizationSchedule
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default AmortizationSchedule;